export default __webpack_public_path__ + "static/media/kabbee-logo.9b0258d3.jpeg";